<template>
  <div class="relative" ref="wrapper">
    <div
      @click="showBlinkerTip"
      v-if="!blinkers.readUnifiedMenuTip"
      class="absolute flex h-4 w-4 blinker z-40 cursor-pointer"
    >
      <span
        class="animate-ping absolute inline-flex h-full w-full rounded-full opacity-50 blinker-color"
      ></span>
      <span
        class="relative inline-flex rounded-full h-full w-full blinker-color"
      ></span>
    </div>
    <div
      class="absolute blinker-details p-4 z-10"
      v-if="showUnifiedIconTip"
      ref="blinkerTip"
    >
      <h5>All your app subscriptions are shown here.</h5>
      <h5 class="font-semibold text-black my-2">
        “Apps so you don’t have any gaps”
      </h5>
      <h5>
        Apps are either installed by you from the open marketplace of bought for
        you by the organizations you have joined.
      </h5>

      <vs-button
        class="mt-2 float-right text-black font-semibold"
        @click="readUnifiedMenu"
        >Got It</vs-button
      >
    </div>

    <!-- NOTIFICATIONS -->
    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer z-10">
      <img
        src="@/assets/images/icons/app-marketplace/unified-app-launch.svg"
        alt="unified-app-launch"
        width="37px"
        height="37px"
        class="cursor-pointer mt-1"
      />

      <vs-dropdown-menu
        class="notification-dropdown dropdown-custom vx-navbar-dropdown"
      >
        <div class="notification-top text-center p-4 bg-primary text-white">
          <h5 class="text-white">Apps</h5>
        </div>

        <component
          :is="scrollbarTag"
          ref="mainSidebarPs"
          class="scroll-area--nofications-dropdown p-0"
          :settings="settings"
          :key="$vs.rtl"
        >
          <div
            v-if="
              userAppSubscriptions && Object.keys(userAppSubscriptions).length
            "
            class="px-4"
          >
            <div class="vx-row">
              <div
                v-for="(appId, index) in Object.keys(userAppSubscriptions)"
                :key="index"
                class="vx-col w-1/3 my-3 items-center"
                v-show="getAppDataById(appId) !== -1"
              >
                <div
                  v-if="
                    userAppSubscriptions[appId] &&
                    userAppSubscriptions[appId].length > 1
                  "
                >
                  <vs-dropdown vs-custom-content>
                    <div class="cursor-pointer">
                      <span
                        class="template-options-btn-icon inline-flex feather-icon text-primary mb-1 cursor-pointer"
                      >
                        <img
                          :src="getAppDataById(appId).icon"
                          width="40px"
                          height="40px"
                          alt=""
                        />
                      </span>
                      <div class="unified-app-title">
                        {{ getAppDataById(appId).shortTitle }}
                      </div>
                    </div>

                    <vs-dropdown-menu
                      style="z-index: 999999; min-width: max-content"
                    >
                      <div>
                        <div class="vx-row p-3 items-center">
                          <div
                            v-for="(appLink, index) in userAppSubscriptions[
                              appId
                            ]"
                            :key="index"
                            class="vx-col items-center"
                          >
                            <span
                              v-if="appId === 'market'"
                              target="_blank"
                              :title="appLink.organizationName"
                              class="items-center cursor-pointer"
                              @click="
                                navigateToMarket(
                                  appLink.organizationId,
                                  authUserData._id
                                )
                              "
                            >
                              <span
                                class="template-options-btn-icon inline-flex feather-icon text-primary mb-1"
                              >
                                <img
                                  :src="getAppDataById(appLink.appId).icon"
                                  width="40px"
                                  height="40px"
                                  alt=""
                                />
                              </span>
                            </span>
                            <a
                              v-else
                              :href="appLink.loginLink"
                              target="_blank"
                              :title="appLink.organizationName"
                              class="items-center"
                            >
                              <span
                                class="template-options-btn-icon inline-flex feather-icon text-primary mb-1"
                              >
                                <img
                                  :src="getAppDataById(appLink.appId).icon"
                                  width="40px"
                                  height="40px"
                                  alt=""
                                />
                              </span>
                            </a>
                          </div>
                        </div>
                      </div>
                    </vs-dropdown-menu>
                  </vs-dropdown>
                </div>
                <div
                  v-else-if="
                    userAppSubscriptions[appId] &&
                    userAppSubscriptions[appId][0] &&
                    getAppDataById(appId) !== -1
                  "
                >
                  <span
                    v-if="appId === 'market'"
                    target="_blank"
                    :title="userAppSubscriptions[appId][0].organizationName"
                    class="items-center cursor-pointer"
                    @click="
                      navigateToMarket(
                        userAppSubscriptions[appId][0].organizationId,
                        authUserData._id
                      )
                    "
                  >
                    <span
                      class="template-options-btn-icon inline-flex feather-icon text-primary mb-1"
                    >
                      <img
                        :src="getAppDataById(appId).icon"
                        width="40px"
                        height="40px"
                        alt=""
                      />
                    </span>
                    <div class="unified-app-title">
                      {{
                        userAppSubscriptions[appId][0].organizationName !==
                          "Gala" &&
                        getAppDataById(appId).shortTitle === "Mentor"
                          ? "Coach"
                          : getAppDataById(appId).shortTitle
                      }}
                    </div>
                  </span>
                  <a
                    v-else
                    :href="userAppSubscriptions[appId][0].loginLink"
                    target="_blank"
                    :title="userAppSubscriptions[appId][0].organizationName"
                    class="items-center"
                  >
                    <span
                      class="template-options-btn-icon inline-flex feather-icon text-primary mb-1"
                    >
                      <img
                        :src="getAppDataById(appId).icon"
                        width="40px"
                        height="40px"
                        alt=""
                      />
                    </span>
                    <div class="unified-app-title">
                      {{
                        userAppSubscriptions[appId][0].organizationName !==
                          "Gala" &&
                        getAppDataById(appId).shortTitle === "Mentor"
                          ? "Coach"
                          : getAppDataById(appId).shortTitle
                      }}
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="items-center py-2">No App Subscriptions Found</div>
        </component>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import marketplaceList from "@/assets/data/marketplace-list.js";

export default {
  components: {
    VuePerfectScrollbar,
  },
  data() {
    return {
      settings: {
        // maxScrollbarLength: 60,
        // wheelSpeed: 0.6,
      },
      marketplaceList,
      showUnifiedIconTip: false,
    };
  },
  computed: {
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
    orgData() {
      return this.$store.state.organization.orgData;
    },
    userData() {
      return this.$store.state.users.data;
    },
    authUserData() {
      return this.$store.state.auth.user;
    },
    userSelectedOrganization() {
      return this.$store.state.users.selectedOrganization;
    },
    userAppSubscriptions() {
      return this.$store.state.users.appSubscriptions;
    },
    userOrganizations() {
      return this.$store.state.users.userOrganizations;
    },
    blinkers() {
      return this.$store.state.dashboard.blinkers;
    },
  },
  watch: {
    userSelectedOrganization() {
      this.fetchUserAppSubscriptions();
    },
  },
  methods: {
    async navigateToMarket(_orgId, _userId) {
      this.$vs.loading();
      const accessToken = localStorage.getItem("accessToken");
      await this.fetchOrgDetailsFromOrgId(_orgId, _userId, accessToken);
    },
    async fetchOrgDetailsFromOrgId(_orgId, _userId, accessToken) {
      this.$store
        .dispatch("users/fetchOrganizationById", _orgId)
        .then((res) => {
          this.$vs.loading.close();
          console.log("org data by id:", res);
          const dynamicMarketPlaceRoute = `https://market.getboarded.com/${res.slug}?userId=${_userId}&authToken=${accessToken}`;
          window.open(dynamicMarketPlaceRoute, "_blank");
        });
    },
    elapsedTime(startTime) {
      let x = new Date(startTime);
      let now = new Date();
      var timeDiff = now - x;
      timeDiff /= 1000;

      var seconds = Math.round(timeDiff);
      timeDiff = Math.floor(timeDiff / 60);

      var minutes = Math.round(timeDiff % 60);
      timeDiff = Math.floor(timeDiff / 60);

      var hours = Math.round(timeDiff % 24);
      timeDiff = Math.floor(timeDiff / 24);

      var days = Math.round(timeDiff % 365);
      timeDiff = Math.floor(timeDiff / 365);

      var years = timeDiff;

      if (years > 0) {
        return years + (years > 1 ? " Years " : " Year ") + "ago";
      } else if (days > 0) {
        return days + (days > 1 ? " Days " : " Day ") + "ago";
      } else if (hours > 0) {
        return hours + (hours > 1 ? " Hrs " : " Hour ") + "ago";
      } else if (minutes > 0) {
        return minutes + (minutes > 1 ? " Mins " : " Min ") + "ago";
      } else if (seconds > 0) {
        return seconds + (seconds > 1 ? " sec ago" : "just now");
      }

      return "Just Now";
    },
    // Method for creating dummy notification time
    randomDate(updatedAt) {
      // let date = new Date()

      // if (hr) date.setHours(date.getHours() - hr)
      // if (min) date.setMinutes(date.getMinutes() - min)
      // if (sec) date.setSeconds(date.getSeconds() - sec)

      return updatedAt;
    },
    fetchUserAppSubscriptions() {
      if (this.userOrganizations && this.userOrganizations.length) {
        this.$store.dispatch("users/fetchUserAppSubscriptions", {
          userId: this.authUserData._id,
          organizationIds: this.userOrganizations.map((uOrg) => {
            return uOrg.organizationId;
          }),
        });
      }
    },
    getAppDataById(id) {
      const appIndex = this.marketplaceList.findIndex((app) => {
        return app.id === id;
      });
      if (appIndex !== -1) return this.marketplaceList[appIndex];
      else return appIndex;
    },
    getOrgData(orgId) {
      if (!orgId || !this.userOrganizations || !this.userOrganizations.length)
        return {};

      const orgData = this.userOrganizations.find((org) => {
        return org.organizationId === orgId;
      });

      if (!orgData || !orgData.organizationData) return {};
      return orgData.organizationData;
    },
    readUnifiedMenu() {
      this.showUnifiedIconTip = false;
      this.$store.commit("dashboard/UPDATE_DASHBOARD_BLINKERS", {
        status: true,
        key: "readUnifiedMenuTip",
      });
    },
    handleClickOutside(event) {
      const popup = this.$refs.blinkerTip;
      const wrapper = this.$refs.wrapper;

      if (!popup.contains(event.target) && !wrapper.contains(event.target)) {
        this.showUnifiedIconTip = false;
        window.removeEventListener("click", this.handleClickOutside);
      }
    },
    showBlinkerTip() {
      this.showUnifiedIconTip = true;
      window.addEventListener("click", this.handleClickOutside);
    },
  },
  created() {
    this.fetchUserAppSubscriptions();
  },
};
</script>

<style lang="scss" scoped>
.notification-dropdown {
  width: 280px !important;
  height: auto !important;
}

.unified-app-title {
  color: #798ba0;
}

.blinker {
  top: 2em;
  right: 1em;
  &-color {
    background: rgba(var(--vs-primary, "#F2C244"), 1) !important;
  }
  &-details {
    background: #fae0a0;
    right: 1em;
    top: 3.5em;
    width: 27.5em;
    border-radius: 8px;
  }
}
</style>
